import Swiper, {Autoplay, Navigation} from 'swiper';
import setupGenericForm from './forms/setup-generic-form';
import setupDealerEventForm from './forms/setup-cms-dealer-event-form';
import createPhotoswipeGallery from '../modules/create-photoswipe-gallery';
import setupTabbedCards from './forms/setup-tabbed-cards';
import setupLiveChatButtons from './modules/setup-live-chat-buttons';
import setFAQs from './modules/faqs';
import setupConfigurator from './modules/configurator';
// import lazyLoad from '../homepages/modules/lazy-load';
import { customEvent } from '../modules/tracking/AnalyticsEvents';
import { initDealerUsedVehicles, initDealerContactForms, initDealerMap } from './modules/dealers';
import { initialiseLatestOffersSlider } from './modules/latest-offers-swiper';
import { initContentGallerySlider } from './modules/content-gallery-slice';
import { setupTrimLevels } from './components/trim-level/setupTrimLevels';

// redesigned slices
import { initUsedVehicles } from './modules/used-vehicles';
import { initServiceCheckInLogin } from './modules/service-check-in-login';
// import { initDealersMap } from './modules/dealers-map';
import { initialiseLatestOffersSliderRedesign } from './modules/latest-offers-swiper-redesign';

require('../jquery.matchHeight');

let swiperInstances = {
    latestNews: null,
    imageGallery: null,
    thinBanners: [],
    newModels: null,
    offerRedesign: null
};

function destroyExistingSwipers() {
    if (swiperInstances.latestNews) {
        swiperInstances.latestNews.destroy(true, true);
        swiperInstances.latestNews = null;
    }
    if (swiperInstances.imageGallery) {
        swiperInstances.imageGallery.destroy(true, true);
        swiperInstances.imageGallery = null;
    }
    swiperInstances.thinBanners.forEach(swiper => {
        if (swiper) swiper.destroy(true, true);
    });
    swiperInstances.thinBanners = [];
    if (swiperInstances.newModels) {
        swiperInstances.newModels.destroy(true, true);
        swiperInstances.newModels = null;
    }
    if (swiperInstances.offerRedesign) {
        swiperInstances.offerRedesign.destroy(true, true);
        swiperInstances.offerRedesign = null;
    }
}

function initialiseCMSContent() {
    destroyExistingSwipers();

    setupTrimLevels();

    // const cmsContentSliceSlickGalleries = document.querySelectorAll('.cms-content-slice__slick-gallery');
    // if (cmsContentSliceSlickGalleries.length > 0) {
    //     for (let index = 0; index < cmsContentSliceSlickGalleries.length; index++) {
    //         if ($(cmsContentSliceSlickGalleries[index]).hasClass('slick-initialized')) {
    //             $(cmsContentSliceSlickGalleries[index]).slick('unslick');
    //         }
    //         $(cmsContentSliceSlickGalleries[index]).slick({
    //             infinite: true,
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //         });
    //     }
    // }
    if (document.querySelector('.cms-finance-application-form')) {
        import('./components/finance-application-form').then(({ default: initialise }) => initialise());
    }

    initContentGallerySlider();

    const galleries = document.querySelectorAll('.lightbox-gallery');
    if (galleries.length > 0) {
        for (let index = 0; index < galleries.length; index++) {
            createPhotoswipeGallery(galleries[index]);
        }
    }

    const genericForms = document.querySelectorAll('form.generic-form');
    if (genericForms.length > 0) {
        for (let index = 0; index < genericForms.length; index++) {
            setupGenericForm(genericForms[index]);
        }
    }

    const dealerEventForms = document.querySelectorAll('form.dealer-event-form');
    if (dealerEventForms.length > 0) {
        for (let index = 0; index < dealerEventForms.length; index++) {
            setupDealerEventForm(dealerEventForms[index]);
        }
    }

    const links = document.querySelectorAll('.cms-content__link');
    const linksLength = links.length;
    if (linksLength > 0) {
        for (let index = 0; index < linksLength; index++) {
            const newLink = links[index].cloneNode(true);
            links[index].parentNode.replaceChild(newLink, links[index]);
            newLink.addEventListener('click', function(event) {
                if (event.target.tagName === 'A' || event.target.tagName === 'BUTTON') {
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                window.location = this.getAttribute('data-link');
            });
        }
    }

    const findDealerSections = document.querySelectorAll('.cms-content-find-dealer');
    // const findDealerSectionsLength = findDealerSections.length;
    // if (findDealerSectionsLength > 0) {
    //     for (let index = 0; index < findDealerSectionsLength; index++) {
    //         lazyLoad(
    //             findDealerSections[index].querySelector('.cms-content-find-dealer__map'),
    //             findDealerSections[index].querySelector('.cms-content-find-dealer__form'),
    //             function(location) {
    //                 if (!window.brand) {
    //                     return true;
    //                 }
    //                 return (location.brand == window.brand);
    //             }
    //         );
    //     }
    // }

    const singleColumnContents = document.querySelectorAll('.cms-content-header-with-image-and-text__content');
    const singleColumnContentsLength = singleColumnContents.length;
    if (singleColumnContentsLength > 0) {
        for (let index = 0; index < singleColumnContentsLength; index++) {
            setupLiveChatButtons(singleColumnContents[index]);
        }
    }

    const latestNewsEl = document.querySelector('.swiper__latest-news');
    if (latestNewsEl) {
        swiperInstances.latestNews = new Swiper('.swiper__latest-news', {
            grabCursor: true,
            slidesPerView: 'auto',
            spaceBetween: 20,
            speed: 400,
        });
    }

    const imageGalleryEl = document.querySelector('.swiper__image-gallery');
    if (imageGalleryEl) {
        swiperInstances.imageGallery = new Swiper('.swiper__image-gallery', {
            grabCursor: true,
            slidesPerView: 1,
            speed: 400,
        });
    }

    const configuratorSlices = document.querySelectorAll('.cms-offer__content-block--configurator');
    const configuratorSlicesLength = configuratorSlices.length;
    if (configuratorSlicesLength > 0) {
        for (let i = 0; i < configuratorSlicesLength; i++) {
            setupConfigurator(configuratorSlices[i]);
        }
    }

    const thinBanners = document.querySelectorAll('.swiper__thin-banners');
    const thinBannersLength = thinBanners.length;
    if (thinBannersLength > 0) {
        for (let i = 0; i < thinBannersLength; i++) {
            if (thinBanners[i].querySelectorAll('.swiper-slide').length <= 1) {
                continue;
            }
            const swiper = new Swiper(thinBanners[i], {
                modules: [Autoplay],
                grabCursor: false,
                slidesPerView: 1,
                speed: 1000,
                direction: 'horizontal',
                loop: true,
                autoplay: {
                    delay: 5000,
                },
            });
            swiperInstances.thinBanners.push(swiper);
        }
    }

    if (window.innerWidth <= 768) {
        const newModelsEl = document.querySelector('.swiper__new-models');
        if (newModelsEl) {
            swiperInstances.newModels = new Swiper('.swiper__new-models', {
                grabCursor: true,
                slidesPerView: 1,
                speed: 400,
            });
        }
    }

    $.fn.matchHeight._update();

    $('.cms-content-slice__trim-name--equal-height').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    $('.cms-content-trim-level__spec-box').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false,
    });

    $('.cms-content-slice__trim-name').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    $('.matchHeight').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    setupTabbedCards();
    setFAQs();

    const sideBySideSlider = document.querySelector(".cms-content-side-by-side__slider");
    if (sideBySideSlider) {
        const firstImage = document.querySelector("[data-split-foreground]");
        const secondImage = document.querySelector("[data-split-background]");
        const sliderButton = document.querySelector(".cms-content-side-by-side__slider--button");
        const sliderLine = document.querySelector(".cms-content-side-by-side__slider--line");
        let interaction = false;

        const newSlider = sideBySideSlider.cloneNode(true);
        sideBySideSlider.parentNode.replaceChild(newSlider, sideBySideSlider);

        newSlider.addEventListener("input", (event) => {
            if (!interaction) {
                customEvent('New Model Search', 'Configurator Image Slider', 'Interacted');
                interaction = true;
            }
            const sliderPos = event.target.value;
            secondImage.style.setProperty("--width", sliderPos + "%");
            secondImage.style.clipPath = "polygon(0% 0%," + sliderPos + "% 0%," + sliderPos + "% 100%,0% 100%)";
            sliderButton.style.setProperty("left", "calc(" + sliderPos + "% - 25px)");
            sliderLine.style.setProperty("left", "calc(" + sliderPos + "% - 5px)");
        });
    }

    initDealerUsedVehicles();
    initDealerMap();
    initDealerContactForms();
    initialiseLatestOffersSlider();

    const cmsOfferRedesignSelectList = document.querySelector('.cms-offers-redesign__select-list');
    if (cmsOfferRedesignSelectList) {
        swiperInstances.offerRedesign = new Swiper(cmsOfferRedesignSelectList, {
            grabCursor: true,
            slidesPerView: 'auto',
            spaceBetween: 10,
            speed: 400,
            direction: 'horizontal',
            breakpoints: {
                768: {
                    spaceBetween: 20,
                },
            },
        });
    }

    // New Redesigned slices
    initialiseLatestOffersSliderRedesign();
    // initDealersMap();
    initUsedVehicles();
    initServiceCheckInLogin();
}

initialiseCMSContent();

window.reloadCMSContentSlices = () => {
    initialiseCMSContent();
};